'use client';

import React, { useMemo, useState } from 'react';
import { Map, AdvancedMarker, InfoWindow } from '@vis.gl/react-google-maps';
import PropTypes from 'prop-types';
import ClinicMapMarker from './ClinicMapMarker';

const DEFAULT_MAP_OPTIONS = {
    zoom: 8,
    center: { lat: 51.3, lng: -0.3 },
    options: {
        disableDefaultUI: true,
        clickableIcons: false,
        zoomControl: true,
    },
    mapId: 'citydoc-find-clinic',
};

ClinicMap.propTypes = {
    selectedAddress: PropTypes.shape({
        address: PropTypes.string,
        lat: PropTypes.number,
        lng: PropTypes.number,
    }),
    results: PropTypes.array.isRequired,
    curTab: PropTypes.string,
    onSelect: PropTypes.func,
};

export default function ClinicMap({ selectedAddress, results, curTab }) {

    let mapDefaultOptions = DEFAULT_MAP_OPTIONS;

    /**
     * Merge options to allow B2B override on map via window.clinicFinderMap
     */
    if(window.clinicFinderMap) {
        mapDefaultOptions = {...DEFAULT_MAP_OPTIONS, ...window.clinicFinderMap};
    } 

    const mapOptions = useMemo(() => mapDefaultOptions.options, []);
    const [infowindowOpen, setInfowindowOpen] = useState(false);
    const [activeMarker, setActiveInfoMarker] = useState(null);
    const [activeResult, setActiveResult] = useState(null);

    const onMarkerSelect = (marker, result) => {
        setInfowindowOpen(true);
        setActiveInfoMarker(marker);
        setActiveResult(result);
    };

    const onCloseMarker = () => {
        setInfowindowOpen(false);
        setActiveInfoMarker(null);
        setActiveResult(null);
    };

    return (
        <>
            <div className="clinic-finder__result-count">{ results.length }</div>   
            <div className={` ${curTab == 'map' ? '' : 'u-hidden'}`}>
                <Map
                    defaultZoom={mapDefaultOptions.zoom}
                    defaultCenter={mapDefaultOptions.center}
                    className="clinic-finder__map"
                    options={mapOptions}
                    mapId={mapDefaultOptions.mapId}
                >
                    {selectedAddress && (
                        <AdvancedMarker
                            position={{
                                lat: selectedAddress.lat,
                                lng: selectedAddress.lng,
                            }}
                        />
                    )}
                    {results.map((result) => (
                        <ClinicMapMarker
                            key={result.id}
                            data={result}
                            onMarkerSelect={onMarkerSelect}
                        />
                    ))}
                    {infowindowOpen && activeResult && (
                        <InfoWindow
                            anchor={activeMarker}
                            maxWidth={250}
                            onCloseClick={onCloseMarker}
                            className="infoWindow"
                        >
                            <h4
                                className="infoWindow__title"
                                dangerouslySetInnerHTML={{
                                    __html: activeResult.title,
                                }}
                            ></h4>
                            <address
                                className="infoWindow__address"
                                dangerouslySetInnerHTML={{
                                    __html: activeResult.address.replace(
                                        /[<]br[^>]*[>]/gi,
                                        ''
                                    ),
                                }}
                            ></address>
                            <p className="infoWindow__directions">
                                
                                <a
                                    className="clinic-finder__clinic-link"
                                    href={`${activeResult.url}`}
                                >
                                    Clinic Details
                                </a>

                                <a
                                    target={'_blank'}
                                    href={`https://www.google.com/maps?saddr=${encodeURI(
                                        selectedAddress?.address ? selectedAddress?.address : 'My+Location'
                                    )}&daddr=${activeResult.lat},${
                                        activeResult.lng
                                    }`}
                                >
                                    Get directions
                                </a>
                                <a
                                    href={`/booking-journey/?clinicID=${activeResult.id}`}
                                >
                                    Make an online booking
                                </a>
                            </p>
                        </InfoWindow>
                    )}
                </Map>
            </div>
        </>
    );
}
